<template>
  <Index :type="5"></Index>
</template>

<script>

import Index from '@/views/components/treeCategoryTable'
export default {
  components: {
    Index
  }
};
</script>

<style lang="scss" scoped>
</style>